<template>
  <b-modal
    dialog-class="md_modal_dialog_full"
    body-class="md_modal_body_scroll pt-0"
    modal-class="md_modal_full"
    content-class="md_modal_content_full"
    header-class="dlg_header"
    :visible="visible"
    hide-footer
    hide-backdrop
    no-close-on-backdrop
    @show="onShow"
    @hide="onCancel"
  >
    <template #modal-header="{close}">
      <div class="popup_title" style="flex: 1; text-align: center;">{{ title }}</div>
      <b-button class="dlg_close_btn" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')" style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
      </b-button>
    </template>
    <div class="full container mt-4">
      <pre style="white-space: break-spaces">
        {{content}}
      </pre>
    </div>
  </b-modal>
</template>

<script>
import Utils from '../../../config/utils'
import SiteItem from "../SiteItem";
const utils = require('util');
export default {
  name: "TermPopup",
  components: {SiteItem},
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: '',
    }
  },

  methods:{
    onCancel()  {
      if(window.history.state == "forward")
        window.history.back();
    },
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },


  },
  inject: ['eventBus'],

}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_vars.scss";

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/TermPopup.vue